<template>
    <el-dialog 
        :visible="openDialog"
        :close-on-click-modal="false"
        title="Import from Job"
        append-to-body
        @close="closeDialog">

        <job-select
            @selected="selectJob"
        ></job-select>

        <span slot="footer" class="dialog-footer">
            <el-button 
                :disabled="processing" 
                @click="closeDialog"
            >
                Close
            </el-button>
            <el-button 
                :disabled="processing || ! job_id"
                @click="process"
                type="success"
            >
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> Add hiring area
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import JobSelect from '../../../accounts/JobSelect/vue/job-select.vue';

export default {
    components: { 
        JobSelect
    },
    props: {
        openDialog: { type: Boolean, required: true },
        areaId: { type: Number, required: true },
    },
    data() {
        return {
            job_id: null,
            processing: false,
        };
    },
    methods: {
        selectJob(result) {
            this.job_id = result.job_id;
        },
        process() {
            this.processing = true;
            this.errorMessage = null;

            axios.post(this.url(`admin/area/import-from-job`), {
                area_id: this.areaId,
                job_id: this.job_id,
            })
            .then(response => {
                this.closeDialog();
                this.$emit('process');
            })
            .finally(() => { this.processing = false; });
        },
        closeDialog() {
            this.$emit('update:openDialog', false);
        },
    },
};
</script>
<style scoped>
.mt-10 {
    margin-top: 10px;
}
</style>